module.exports = __webpack_public_path__ + "static/media/404.960da083.png";